/***
 * @file:è·¯ç±åæ´æå¡
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, GuardsCheckEnd, NavigationEnd, Router } from '@angular/router';
import { isEmpty } from 'lodash';
import { values } from 'lodash';
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UrlChangeService {
  // é¡µé¢è·¯ç±
  location;
  urlChange$ = new Subject();
  beforeUrl$ = new Subject();
  routerTreeInfo: any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private locationService: Location) {
    this.location = this.locationService;
  }

  // éè¿è·¯ç±è·³è½¬è·åæ é¢
  getTitleByRouterChange() {
    this.beforeRouter();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary')
        // è¿åæ´ä¸ªè·¯ç±å¯¹è±¡ï¼ä¾åé¢ä½¿ç¨
        // mergeMap((route) => {
        //   return route.data;
        //   // return route.params;
        // })
      )
      .subscribe((event: any) => {
        const params: any = event['params'] || {}; // è·¯ç±åæ°
        const data: any = event['data'] || {}; // è·¯ç±æ°æ®
        let pureRouter = this.getCurrentRouter(); // çº¯åçè·¯ç±ï¼ä¸å¸¦åæ°ç
        // å¦ææ¯`user/:id`è¿æ ·æºå¸¦çåæ°ï¼åå¾ªç¯å é¤ï¼è·å¾çº¯åçè·¯ç±
        if (!isEmpty(params.value)) {
          const _values: string[] = values(params.value);
          _values.forEach((value) => {
            pureRouter = this.pureRouter(pureRouter, value);
          });
        }
        // è·åå½åå°åï¼è¥å¸¦'?'ååé¤å¶åå¶åé¢åå®¹
        const dataMerge: any = {
          url: this.fullPath,
          pureRouter,
          title: data.value['title'],
        };

        this.urlChange$.next(dataMerge);
      });
  }

  // è·¯ç±ååä¹åæ¦æª
  beforeRouter() {
    this.router.events.pipe(filter((event) => event instanceof GuardsCheckEnd)).subscribe((event: any) => {
      this.routerTreeInfo = null; // éç½®å­å¨çè·¯ç±ä¿¡æ¯
      this.getRouterInfo(event.state.root._routerState._root); // è·å¾è·¯ç±æºå¸¦çä¿¡æ¯
      const data: any = this.routerTreeInfo['data'] || {}; // è·¯ç±æ°æ®
      const url = event.state.root._routerState.url; // è·åè¦å°çurl
      const pureRouter = this.getCurrentRouter(url); // ååºæºå¸¦çåæ°ï¼è·çè·¯ç±ä¿¡æ¯
      const dataMerge = {
        url,
        pureRouter,
        title: data['title'],
      };
      this.beforeUrl$.next(dataMerge);
    });
  }

  // å é¤`?id=1` è¿æ ·çåæ°ï¼ä½æ¯ä¼åå«`user/:id`è¿æ ·çåæ°
  getCurrentRouter(url?): string {
    let path = url || this.fullPath;
    if (path.indexOf('?') > -1) {
      path = path.slice(0, path.indexOf('?'));
    }
    return path;
  }

  // å®æ´çè·¯å¾ï¼åæ¬ææåæ°
  get fullPath(): string {
    return decodeURIComponent(this.location.path());
  }

  // å é¤ææåæ°ï¼åå«`user/:id`å`?id=123`
  pureRouter(curRouter, param): string {
    const paramMerge = `/${param}`;
    if (curRouter.lastIndexOf(paramMerge) > -1) {
      curRouter = curRouter.slice(0, curRouter.indexOf(paramMerge));
    }
    return curRouter;
  }

  getParam(key) {
    const subStr = `${key}=`;
    let url = this.location.path();
    const tokenIdx = url.indexOf(subStr);
    if (tokenIdx < 0) {
      return null;
    }
    const idx = tokenIdx + subStr.length;
    if (idx > -1) {
      url = url.slice(idx);
    }

    return url;
  }

  // å¾ªç¯è·¯ææ ç»æååºæåä¸å±æ°æ®
  getRouterInfo(routerTree: any) {
    if (routerTree.children.length > 0) {
      this.getRouterInfo(routerTree.children[0]);
    } else {
      this.routerTreeInfo = routerTree.value;
    }
  }
}
